/**
 * Mapping of backend category names to display names
 * Use this to customize how category names appear in tooltips and alt text
 * without changing the backend data
 */
const categoryDisplayNames = {
  Erfgoed: 'Erfgoedlocatie',
  Kinderactiviteit: 'Kinderen en families',
  'Natuur- & Landschapbescherming': 'Natuur- en Landschapsbeheer',
}

/**
 * Get the display name for a category
 * @param {string} category - The backend category name
 * @returns {string} - The display name (or original if no mapping exists)
 */
const getCategoryDisplayName = (category) => {
  if (!category) return 'Overig'
  return categoryDisplayNames[category] || category
}

export default getCategoryDisplayName
